import AdminRoute from './components/AdminRoute';
import Login from './admin/Login';
import Dashboard from './admin/Dashboard';
import PhotoGallery from './admin/PhotoGallery';
import PhotoGalleryView from './admin/PhotoGalleryView';
import Photos from './admin/Photos';
import Categories from './admin/Categories';
import Inquiries from './admin/Inquiries';
import ChangePassword from './admin/ChangePassword';
import ForgotPassword from './admin/ForgotPassword';
import AboutAdmin from './admin/AboutAdmin';

import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import GalleryPage from './pages/GalleryPage';
import Contact from './pages/Contact';
import Testimonials from './pages/Testimonials';
import About from './pages/About';
import { AuthProvider } from './contexts/AuthContext';
import usePageTracking from './hooks/usePageTracking';

function AppRoutes() {
  usePageTracking();
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/gallery" element={<GalleryPage />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/testimonials" element={<Testimonials />} />
      <Route path="/about" element={<About />} />
      <Route path="/admin/login" element={<Login />} />
      <Route path="/admin/change-password" element={<AdminRoute><ChangePassword /></AdminRoute>} />
      <Route path="/admin/forgot-password" element={<ForgotPassword />} />
      <Route path="/admin/dashboard" element={<AdminRoute><Dashboard /></AdminRoute>} />
      <Route path="/admin/photo-gallery" element={<AdminRoute><PhotoGallery /></AdminRoute>} />
      <Route path="/admin/photo-gallery/:categoryId" element={<AdminRoute><PhotoGalleryView /></AdminRoute>} />
      <Route path="/admin/photos" element={<AdminRoute><Photos /></AdminRoute>} />
      <Route path="/admin/categories" element={<AdminRoute><Categories /></AdminRoute>} />
      <Route path="/admin/inquiries" element={<AdminRoute><Inquiries /></AdminRoute>} />
      <Route path="/admin/about" element={<AdminRoute><AboutAdmin /></AdminRoute>} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
